import { useEffect, useState } from "react";
import { ExternalLink, Zap } from "lucide-react";
import { api, track } from "../../lib/api";
import { getAttribution } from "../../lib/attribution";

const MC_LOGO = (code) => `https://api.connect.travelaudience.com/static/img/airlines/small/${code}.png`;
const fmtD = (iso) => new Date(iso).toLocaleDateString(undefined, { day: "numeric", month: "short" });

export const FareAdCard = ({ merchantCode, airlineName, origin, destination }) => {
  const [offer, setOffer] = useState(null);
  const [done, setDone] = useState(false);

  useEffect(() => {
    if (!merchantCode || !origin || !destination) { setDone(true); return; }
    const attr = getAttribution();
    api.get("/metaconnect/adfare", {
      params: { merchant: merchantCode, origin, destination, aff: attr.aff || "", vid: attr.vid || "" },
      timeout: 45000,
    })
      .then((r) => setOffer(r.data.offer))
      .catch(() => {})
      .finally(() => setDone(true));
  }, [merchantCode, origin, destination]);

  if (!done || !offer) return null;

  const open = () => {
    track("metaconnect_offer_click", `/flights/ad/${merchantCode}`, {
      merchant: offer.merchant, price: offer.price, route: `${origin}-${destination}`, placement: "airline_ad_card",
    });
    window.open(offer.deep_link, "_blank", "noopener");
  };

  return (
    <section className="max-w-6xl mx-auto px-4 sm:px-6 mt-8" data-testid={`fare-ad-card-${merchantCode}`}>
      <div className="bg-[#0B1527] border border-[#1E293B] rounded-sm p-4 sm:p-5 flex flex-col sm:flex-row sm:items-center gap-4">
        <div className="flex items-center gap-3 flex-1 min-w-0">
          <img src={MC_LOGO(offer.merchant)} alt={airlineName} className="w-9 h-9 object-contain rounded-sm bg-white/90 p-0.5 shrink-0" onError={(e) => { e.currentTarget.style.display = "none"; }} />
          <div className="min-w-0">
            <p className="text-[9px] font-mono uppercase tracking-widest text-slate-500 flex items-center gap-1.5">
              <Zap className="w-3 h-3 text-[#00E5FF]" /> Live fare · {airlineName} official site
            </p>
            <p className="font-mono font-bold text-white text-sm mt-0.5 truncate">
              {origin} → {destination} return · {fmtD(offer.departure_date)} – {fmtD(offer.return_date)}
            </p>
          </div>
        </div>
        <div className="flex items-center gap-4 sm:flex-col sm:items-end sm:gap-1 shrink-0">
          <p className="font-heading text-xl font-bold text-white" style={{ fontVariantNumeric: "tabular-nums" }}>
            <span className="text-xs text-slate-400 font-sans font-normal mr-1">{offer.currency}</span>
            {Number(offer.price).toLocaleString()}
          </p>
          <button
            data-testid={`fare-ad-book-${merchantCode}`}
            onClick={open}
            className="inline-flex items-center gap-1.5 bg-[#00E5FF] hover:bg-[#33EBFF] text-black font-bold text-xs px-4 py-2 rounded-sm uppercase tracking-wide transition-colors duration-200"
          >
            Book on {airlineName} <ExternalLink className="w-3.5 h-3.5" />
          </button>
        </div>
      </div>
    </section>
  );
};
